
import Axeptio from './Axeptio.vue';

export default {
  name: 'Cookies',
  components: {
    Axeptio,
  },
};
